export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Json: any;
  Upload: any;
};

export type AnnualRevenue = {
  __typename?: 'AnnualRevenue';
  setting_annual_revenue_id?: Maybe<Scalars['Int']>;
  setting_annual_revenue_name?: Maybe<Scalars['String']>;
};

export type Bank = {
  __typename?: 'Bank';
  bank_created?: Maybe<Scalars['DateTime']>;
  bank_id?: Maybe<Scalars['Int']>;
  bank_logo?: Maybe<Images>;
  bank_name?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Int']>;
};

export type BusinessType = {
  __typename?: 'BusinessType';
  business_type_id?: Maybe<Scalars['Int']>;
  business_type_name?: Maybe<Scalars['Json']>;
  business_type_status?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of BusinessType items. */
export type BusinessTypePaginator = {
  __typename?: 'BusinessTypePaginator';
  /** A list of BusinessType items. */
  data: Array<BusinessType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BusinessYear = {
  __typename?: 'BusinessYear';
  is_deleted?: Maybe<Scalars['Boolean']>;
  year_of_business_id?: Maybe<Scalars['Int']>;
  year_of_business_name?: Maybe<Scalars['Json']>;
  year_of_business_status?: Maybe<Scalars['String']>;
};

/** A paginated list of BusinessYear items. */
export type BusinessYearPaginator = {
  __typename?: 'BusinessYearPaginator';
  /** A list of BusinessYear items. */
  data: Array<BusinessYear>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type City = {
  __typename?: 'City';
  city_id: Scalars['Int'];
  city_name: Scalars['String'];
  is_deleted?: Maybe<Scalars['Int']>;
  state?: Maybe<State>;
};

export type CompanySize = {
  __typename?: 'CompanySize';
  setting_company_size_id?: Maybe<Scalars['Int']>;
  setting_company_size_name?: Maybe<Scalars['String']>;
};

export type ContactUs = {
  __typename?: 'ContactUs';
  contact_us_action_admin_id?: Maybe<Scalars['Int']>;
  contact_us_action_remark?: Maybe<Scalars['String']>;
  contact_us_company_name?: Maybe<Scalars['String']>;
  contact_us_id?: Maybe<Scalars['Int']>;
  contact_us_loan_amount?: Maybe<Scalars['Float']>;
  contact_us_message?: Maybe<Scalars['String']>;
  contact_us_status?: Maybe<ContactUsStatus>;
  contact_us_user_email?: Maybe<Scalars['String']>;
  contact_us_user_firstname?: Maybe<Scalars['String']>;
  contact_us_user_lastname?: Maybe<Scalars['String']>;
  contact_us_user_mobile?: Maybe<Scalars['String']>;
};

export enum ContactUsStatus {
  Completed = 'completed',
  Pending = 'pending',
  Rejected = 'rejected',
}

export type ContactUsStatusCount = {
  __typename?: 'ContactUsStatusCount';
  contact_us_status?: Maybe<ContactUsStatus>;
  total?: Maybe<Scalars['Int']>;
};

export type Country = {
  __typename?: 'Country';
  country_code?: Maybe<Scalars['String']>;
  country_currency_code?: Maybe<Scalars['String']>;
  country_id?: Maybe<Scalars['Int']>;
  country_international_code?: Maybe<Scalars['String']>;
  country_name?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Int']>;
  state?: Maybe<Array<Maybe<State>>>;
};

export type Customer = {
  __typename?: 'Customer';
  bank?: Maybe<Bank>;
  business_type?: Maybe<BusinessType>;
  business_year?: Maybe<BusinessYear>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  customer_address?: Maybe<Scalars['String']>;
  customer_address2?: Maybe<Scalars['String']>;
  customer_annual_revenue?: Maybe<CustomerAnnualRevenue>;
  customer_approved?: Maybe<Scalars['DateTime']>;
  customer_bank_account_name?: Maybe<Scalars['String']>;
  customer_bank_account_number?: Maybe<Scalars['String']>;
  customer_company_size?: Maybe<CustomerCompanySize>;
  customer_contact_person?: Maybe<Scalars['String']>;
  customer_contact_person_email?: Maybe<Scalars['String']>;
  customer_contact_person_mobile?: Maybe<Scalars['String']>;
  customer_contact_person_role?: Maybe<CustomerContactPersonRole>;
  customer_created?: Maybe<Scalars['DateTime']>;
  customer_email?: Maybe<Scalars['String']>;
  customer_fax?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  customer_log?: Maybe<Array<Maybe<CustomerLog>>>;
  customer_mobile?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_postcode?: Maybe<Scalars['String']>;
  customer_question?: Maybe<Array<Maybe<CustomerQuestion>>>;
  customer_registration_number?: Maybe<Scalars['String']>;
  customer_remark?: Maybe<Scalars['String']>;
  customer_status?: Maybe<CustomerStatus>;
  customer_type?: Maybe<CustomerType>;
  customer_updated?: Maybe<Scalars['DateTime']>;
  customer_website?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  reject_reason?: Maybe<RejectReason>;
  reject_reason_remark?: Maybe<Scalars['String']>;
  setting_annual_revenue?: Maybe<AnnualRevenue>;
  setting_company_size?: Maybe<CompanySize>;
  ssm_business_certificate?: Maybe<Array<Maybe<Media>>>;
  state?: Maybe<State>;
  user?: Maybe<User>;
};

export enum CustomerAnnualRevenue {
  /** 10000-100000 */
  Between_10000_100000 = 'BETWEEN_10000_100000',
  /** 10000- */
  LessThan_10000 = 'LESS_THAN_10000',
  /** 100000+ */
  MoreThan_100000 = 'MORE_THAN_100000',
}

export type CustomerBank = {
  __typename?: 'CustomerBank';
  bank?: Maybe<Bank>;
  customer?: Maybe<Customer>;
  customer_bank_account_number?: Maybe<Scalars['Int']>;
  customer_bank_created?: Maybe<Scalars['DateTime']>;
  customer_bank_holder_name?: Maybe<Scalars['String']>;
  customer_bank_id?: Maybe<Scalars['Int']>;
  customer_bank_updated?: Maybe<Scalars['DateTime']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
};

export type CustomerBankAccountUpdateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  customer_bank_account_name?: InputMaybe<Scalars['String']>;
  customer_bank_account_number?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerBankCreateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  customer_bank_account_number?: InputMaybe<Scalars['Int']>;
  customer_bank_holder_name?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerBankUpdateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  customer_bank_account_number?: InputMaybe<Scalars['Int']>;
  customer_bank_holder_name?: InputMaybe<Scalars['String']>;
  customer_bank_id?: InputMaybe<Scalars['Int']>;
  customer_id?: InputMaybe<Scalars['Int']>;
};

export enum CustomerCompanySize {
  /** 11-25 */
  Between_11_25 = 'BETWEEN_11_25',
  /** 26-50 */
  Between_26_50 = 'BETWEEN_26_50',
  /** 1-10 */
  LessThan_10 = 'LESS_THAN_10',
  /** 50+ */
  MoreThan_50 = 'MORE_THAN_50',
}

export enum CustomerContactPersonRole {
  Owner = 'Owner',
  Partner = 'Partner',
}

export type CustomerContactPersonUpdateInput = {
  customer_contact_person?: InputMaybe<Scalars['String']>;
  customer_contact_person_email?: InputMaybe<Scalars['String']>;
  customer_contact_person_mobile?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerCreateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  business_type_id?: InputMaybe<Scalars['Int']>;
  city_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  customer_address?: InputMaybe<Scalars['String']>;
  customer_address2?: InputMaybe<Scalars['String']>;
  customer_annual_revenue?: InputMaybe<CustomerAnnualRevenue>;
  customer_bank_account_name?: InputMaybe<Scalars['String']>;
  customer_bank_account_number?: InputMaybe<Scalars['String']>;
  customer_company_size?: InputMaybe<CustomerCompanySize>;
  customer_contact_person_role?: InputMaybe<CustomerContactPersonRole>;
  customer_email?: InputMaybe<Scalars['String']>;
  customer_mobile?: InputMaybe<Scalars['String']>;
  customer_name?: InputMaybe<Scalars['String']>;
  customer_postcode?: InputMaybe<Scalars['String']>;
  customer_question?: InputMaybe<Array<InputMaybe<CustomerQuestionInput>>>;
  customer_registration_number?: InputMaybe<Scalars['String']>;
  customer_remark?: InputMaybe<Scalars['String']>;
  customer_type?: InputMaybe<CustomerType>;
  customer_website?: InputMaybe<Scalars['String']>;
  setting_annual_revenue_id?: InputMaybe<Scalars['Int']>;
  setting_company_size_id?: InputMaybe<Scalars['Int']>;
  ssm_business_certificate?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  state_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  year_of_business_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerDetailsUpdateInput = {
  business_type_id?: InputMaybe<Scalars['Int']>;
  city_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  customer_address?: InputMaybe<Scalars['String']>;
  customer_address2?: InputMaybe<Scalars['String']>;
  customer_annual_revenue?: InputMaybe<CustomerAnnualRevenue>;
  customer_company_size?: InputMaybe<CustomerCompanySize>;
  customer_id?: InputMaybe<Scalars['Int']>;
  customer_name?: InputMaybe<Scalars['String']>;
  customer_postcode?: InputMaybe<Scalars['String']>;
  customer_registration_number?: InputMaybe<Scalars['String']>;
  customer_status?: InputMaybe<CustomerStatus>;
  customer_website?: InputMaybe<Scalars['String']>;
  setting_annual_revenue_id?: InputMaybe<Scalars['Int']>;
  setting_company_size_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
  year_of_business_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerFullDetail = {
  __typename?: 'CustomerFullDetail';
  approve_reject_details?: Maybe<CustomerLog>;
  business_type?: Maybe<BusinessType>;
  business_type_id?: Maybe<Scalars['Int']>;
  business_year?: Maybe<BusinessYear>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  customer_address?: Maybe<Scalars['String']>;
  customer_address2?: Maybe<Scalars['String']>;
  customer_annual_revenue?: Maybe<CustomerAnnualRevenue>;
  customer_approved?: Maybe<Scalars['DateTime']>;
  customer_company_size?: Maybe<CustomerCompanySize>;
  customer_contact_person?: Maybe<Scalars['String']>;
  customer_contact_person_email?: Maybe<Scalars['String']>;
  customer_contact_person_mobile?: Maybe<Scalars['String']>;
  customer_contact_person_role?: Maybe<CustomerContactPersonRole>;
  customer_created?: Maybe<Scalars['DateTime']>;
  customer_email?: Maybe<Scalars['String']>;
  customer_fax?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  customer_mobile?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_postcode?: Maybe<Scalars['String']>;
  customer_question?: Maybe<Array<Maybe<CustomerQuestion>>>;
  customer_registration_number?: Maybe<Scalars['String']>;
  customer_remark?: Maybe<Scalars['String']>;
  customer_status?: Maybe<CustomerStatus>;
  customer_type?: Maybe<CustomerType>;
  customer_updated?: Maybe<Scalars['DateTime']>;
  customer_user?: Maybe<Array<Maybe<CustomerUser>>>;
  customer_website?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  setting_annual_revenue?: Maybe<AnnualRevenue>;
  setting_company_size?: Maybe<CompanySize>;
  ssm_business_certificate?: Maybe<Array<Maybe<Media>>>;
  state?: Maybe<State>;
  total_card?: Maybe<Scalars['Int']>;
  total_recipient?: Maybe<Scalars['Int']>;
  total_transaction?: Maybe<Scalars['Int']>;
  total_usage?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
  year_of_business_id?: Maybe<Scalars['Int']>;
};

export type CustomerLessDetail = {
  __typename?: 'CustomerLessDetail';
  customer_email?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  customer_mobile?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_type?: Maybe<CustomerType>;
  user?: Maybe<User>;
};

export type CustomerListing = {
  __typename?: 'CustomerListing';
  business_type_id?: Maybe<BusinessType>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  customer_address?: Maybe<Scalars['String']>;
  customer_address2?: Maybe<Scalars['String']>;
  customer_annual_revenue?: Maybe<CustomerAnnualRevenue>;
  customer_approved?: Maybe<Scalars['DateTime']>;
  customer_company_size?: Maybe<CustomerCompanySize>;
  customer_contact_person?: Maybe<Scalars['String']>;
  customer_contact_person_email?: Maybe<Scalars['String']>;
  customer_contact_person_mobile?: Maybe<Scalars['String']>;
  customer_contact_person_role?: Maybe<CustomerContactPersonRole>;
  customer_created?: Maybe<Scalars['DateTime']>;
  customer_email?: Maybe<Scalars['String']>;
  customer_fax?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  customer_mobile?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_postcode?: Maybe<Scalars['String']>;
  customer_question?: Maybe<Array<Maybe<CustomerQuestion>>>;
  customer_registration_number?: Maybe<Scalars['String']>;
  customer_remark?: Maybe<Scalars['String']>;
  customer_status?: Maybe<CustomerStatus>;
  customer_type?: Maybe<CustomerType>;
  customer_updated?: Maybe<Scalars['DateTime']>;
  customer_user?: Maybe<Array<Maybe<CustomerUser>>>;
  customer_website?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  setting_annual_revenue?: Maybe<AnnualRevenue>;
  setting_company_size?: Maybe<CompanySize>;
  ssm_business_certificate?: Maybe<Array<Maybe<Media>>>;
  state?: Maybe<State>;
  total_card?: Maybe<Scalars['Int']>;
  total_fee?: Maybe<Scalars['Float']>;
  total_recipient?: Maybe<Scalars['Int']>;
  total_transaction?: Maybe<Scalars['Int']>;
  total_usage?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
  year_of_business_id?: Maybe<BusinessYear>;
};

export type CustomerLog = {
  __typename?: 'CustomerLog';
  customer?: Maybe<Customer>;
  customer_log_action?: Maybe<Scalars['String']>;
  customer_log_created?: Maybe<Scalars['DateTime']>;
  customer_log_description?: Maybe<Scalars['String']>;
  customer_log_id?: Maybe<Scalars['Int']>;
  customer_log_remark?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<RejectReason>;
  user?: Maybe<User>;
};

export enum CustomerLogAction {
  Approve = 'approve',
  Create = 'create',
  Reject = 'reject',
  UpdateProfile = 'update_profile',
}

export enum CustomerMerchantStatus {
  Active = 'active',
  Suspended = 'suspended',
}

export type CustomerProfileUpdateInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  customer_address?: InputMaybe<Scalars['String']>;
  customer_address2?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  customer_name?: InputMaybe<Scalars['String']>;
  customer_postcode?: InputMaybe<Scalars['String']>;
  customer_registration_number?: InputMaybe<Scalars['String']>;
  customer_website?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerQuestion = {
  __typename?: 'CustomerQuestion';
  customer?: Maybe<Customer>;
  customer_question_created?: Maybe<Scalars['DateTime']>;
  customer_question_id?: Maybe<Scalars['Int']>;
  customer_question_title?: Maybe<Scalars['String']>;
  customer_question_value?: Maybe<Scalars['Json']>;
  question?: Maybe<Question>;
};

export type CustomerQuestionInput = {
  customer_question_title?: InputMaybe<Scalars['String']>;
  customer_question_value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  question_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerSsmUpdateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  ssm_business_certificate?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  ssm_business_certificate_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum CustomerStatus {
  Active = 'Active',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Suspend = 'Suspend',
}

export enum CustomerType {
  Company = 'Company',
  Personal = 'Personal',
}

export type CustomerUpdateInput = {
  business_type_id?: InputMaybe<Scalars['Int']>;
  city_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  customer_address?: InputMaybe<Scalars['String']>;
  customer_address2?: InputMaybe<Scalars['String']>;
  customer_annual_revenue?: InputMaybe<CustomerAnnualRevenue>;
  customer_company_size?: InputMaybe<CustomerCompanySize>;
  customer_contact_person?: InputMaybe<Scalars['String']>;
  customer_contact_person_email?: InputMaybe<Scalars['String']>;
  customer_contact_person_mobile?: InputMaybe<Scalars['String']>;
  customer_email?: InputMaybe<Scalars['String']>;
  customer_fax?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  customer_mobile?: InputMaybe<Scalars['String']>;
  customer_name?: InputMaybe<Scalars['String']>;
  customer_postcode?: InputMaybe<Scalars['String']>;
  customer_question?: InputMaybe<Array<InputMaybe<CustomerQuestionInput>>>;
  customer_registration_number?: InputMaybe<Scalars['String']>;
  customer_remark?: InputMaybe<Scalars['String']>;
  customer_status?: InputMaybe<CustomerStatus>;
  customer_type?: InputMaybe<CustomerType>;
  customer_website?: InputMaybe<Scalars['String']>;
  setting_annual_revenue_id?: InputMaybe<Scalars['Int']>;
  setting_company_size_id?: InputMaybe<Scalars['Int']>;
  ssm_business_certificate?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  ssm_business_certificate_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  state_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  year_of_business_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerUser = {
  __typename?: 'CustomerUser';
  customer?: Maybe<Customer>;
  customer_user_id?: Maybe<Scalars['Int']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type CustomerUserCreateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type CustomerUserListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
};

/** A paginated list of CustomerUser items. */
export type CustomerUserPaginator = {
  __typename?: 'CustomerUserPaginator';
  /** A list of CustomerUser items. */
  data: Array<CustomerUser>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CustomerUserUpdateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  customer_user_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type DashboardMerchantData = {
  __typename?: 'DashboardMerchantData';
  payment_listing?: Maybe<PaymentPaginator>;
  payment_overview?: Maybe<Array<Maybe<PaymentOverviewData>>>;
  spending_allocation?: Maybe<SpendingAllocation>;
  upcoming_recurring_payment?: Maybe<Array<Maybe<PaymentSchedule>>>;
};

export type DashboardMerchantDataPayment_ListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type DashboardMerchantDataPayment_OverviewArgs = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type DashboardMerchantDataSpending_AllocationArgs = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type DashboardMerchantStatus = {
  __typename?: 'DashboardMerchantStatus';
  data?: Maybe<DashboardMerchantData>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
}

export type ImageDetail = {
  __typename?: 'ImageDetail';
  media_id?: Maybe<Scalars['Int']>;
  url_media?: Maybe<Scalars['String']>;
};

export type Images = {
  __typename?: 'Images';
  full?: Maybe<Scalars['String']>;
  media_id?: Maybe<Scalars['Int']>;
  thumb?: Maybe<Scalars['String']>;
};

export enum Language {
  /** Bahasa Malaysia */
  Bm = 'bm',
  /** Chinese */
  Cn = 'cn',
  /** English */
  En = 'en',
}

export type LanguageStringInput = {
  bm?: InputMaybe<Scalars['String']>;
  cn?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
};

export type LoginInput = {
  device_id: Scalars['String'];
  password: Scalars['String'];
  user_mobile: Scalars['String'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  TokenResponse?: Maybe<TokenResponse>;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type Media = {
  __typename?: 'Media';
  collection_name?: Maybe<Scalars['String']>;
  conversions?: Maybe<Scalars['Json']>;
  file_name?: Maybe<Scalars['String']>;
  full_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mime_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MerchantCustomer = {
  __typename?: 'MerchantCustomer';
  city?: Maybe<City>;
  country?: Maybe<Country>;
  full_address?: Maybe<Scalars['String']>;
  merchant?: Maybe<Customer>;
  merchant_customer_address_1?: Maybe<Scalars['String']>;
  merchant_customer_address_2?: Maybe<Scalars['String']>;
  merchant_customer_company_name?: Maybe<Scalars['String']>;
  merchant_customer_created?: Maybe<Scalars['DateTime']>;
  merchant_customer_email?: Maybe<Scalars['String']>;
  merchant_customer_id?: Maybe<Scalars['Int']>;
  merchant_customer_name?: Maybe<Scalars['String']>;
  merchant_customer_phone_number?: Maybe<Scalars['String']>;
  merchant_customer_postcode?: Maybe<Scalars['String']>;
  merchant_customer_registration_number?: Maybe<Scalars['String']>;
  merchant_customer_status?: Maybe<CustomerMerchantStatus>;
  merchant_customer_updated?: Maybe<Scalars['DateTime']>;
  payment?: Maybe<Array<Maybe<PaymentLink>>>;
  payment_link_transaction_count?: Maybe<Scalars['Int']>;
  payment_link_transaction_total?: Maybe<Scalars['Float']>;
  state?: Maybe<State>;
};

export type MerchantCustomerCreateInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  merchant_customer_address_1?: InputMaybe<Scalars['String']>;
  merchant_customer_address_2?: InputMaybe<Scalars['String']>;
  merchant_customer_company_name?: InputMaybe<Scalars['String']>;
  merchant_customer_email?: InputMaybe<Scalars['String']>;
  merchant_customer_name?: InputMaybe<Scalars['String']>;
  merchant_customer_phone_number?: InputMaybe<Scalars['String']>;
  merchant_customer_postcode?: InputMaybe<Scalars['String']>;
  merchant_customer_registration_number?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

export type MerchantCustomerDropdown = {
  __typename?: 'MerchantCustomerDropdown';
  merchant_customer_company_name?: Maybe<Scalars['String']>;
  merchant_customer_id?: Maybe<Scalars['Int']>;
  merchant_customer_name?: Maybe<Scalars['String']>;
  merchant_customer_registration_number?: Maybe<Scalars['String']>;
};

export type MerchantCustomerListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['Date']>;
  keyword?: InputMaybe<Scalars['String']>;
  merchant_customer_status?: InputMaybe<CustomerMerchantStatus>;
  start_date?: InputMaybe<Scalars['Date']>;
};

/** A paginated list of MerchantCustomer items. */
export type MerchantCustomerPaginator = {
  __typename?: 'MerchantCustomerPaginator';
  /** A list of MerchantCustomer items. */
  data: Array<MerchantCustomer>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type MerchantCustomerStatusCount = {
  __typename?: 'MerchantCustomerStatusCount';
  merchant_customer_status?: Maybe<Scalars['String']>;
  status_count?: Maybe<Scalars['Int']>;
};

export type MerchantCustomerStatusUpdateInput = {
  merchant_customer_id?: InputMaybe<Scalars['Int']>;
  merchant_customer_status?: InputMaybe<CustomerMerchantStatus>;
};

export type MerchantCustomerUpdateInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  merchant_customer_address_1?: InputMaybe<Scalars['String']>;
  merchant_customer_address_2?: InputMaybe<Scalars['String']>;
  merchant_customer_company_name?: InputMaybe<Scalars['String']>;
  merchant_customer_email?: InputMaybe<Scalars['String']>;
  merchant_customer_id?: InputMaybe<Scalars['Int']>;
  merchant_customer_name?: InputMaybe<Scalars['String']>;
  merchant_customer_phone_number?: InputMaybe<Scalars['String']>;
  merchant_customer_postcode?: InputMaybe<Scalars['String']>;
  merchant_customer_registration_number?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

export type Message = {
  __typename?: 'Message';
  is_published: Scalars['Int'];
  message: Scalars['String'];
  message_id: Scalars['Int'];
  message_priority?: Maybe<Scalars['Int']>;
  message_slug: Scalars['String'];
};

export type MessageLessDetail = {
  __typename?: 'MessageLessDetail';
  message: Scalars['String'];
  message_id: Scalars['Int'];
};

export enum MessageType {
  LocationFeedback = 'location_feedback',
  TransactionReservationCancel = 'transaction_reservation_cancel',
  UserDeleteReason = 'user_delete_reason',
}

export type Mutation = {
  __typename?: 'Mutation';
  CustomerBankAccountUpdate?: Maybe<SuccessResponse>;
  CustomerBankCreate?: Maybe<SuccessResponse>;
  CustomerBankUpdate?: Maybe<SuccessResponse>;
  CustomerContactPersonUpdate?: Maybe<SuccessResponse>;
  CustomerCreate?: Maybe<SuccessResponse>;
  CustomerDetailsUpdate?: Maybe<SuccessResponse>;
  CustomerProfileUpdate?: Maybe<SuccessResponse>;
  CustomerRequestApproval?: Maybe<SuccessResponse>;
  CustomerSSMUpdate?: Maybe<SuccessResponse>;
  CustomerUpdate?: Maybe<SuccessResponse>;
  CustomerUserCreate?: Maybe<SuccessResponse>;
  CustomerUserDelete?: Maybe<SuccessResponse>;
  CustomerUserUpdate?: Maybe<SuccessResponse>;
  Login?: Maybe<LoginResponse>;
  Logout?: Maybe<SuccessResponse>;
  MerchantCustomerCreate?: Maybe<SuccessResponse>;
  MerchantCustomerStatusUpdate?: Maybe<SuccessResponse>;
  MerchantCustomerUpdate?: Maybe<SuccessResponse>;
  PaymentCancel?: Maybe<SuccessResponse>;
  PaymentCreate?: Maybe<SuccessResponse>;
  PaymentLinkCalculate?: Maybe<PaymentCalculation>;
  PaymentLinkCreate?: Maybe<SuccessResponse>;
  PaymentRefund?: Maybe<SuccessResponse>;
  PaymentScheduleCancel?: Maybe<SuccessResponse>;
  PaymentScheduleMake?: Maybe<SuccessResponse>;
  PaymentScheduleRefund?: Maybe<SuccessResponse>;
  PaymentUpdate?: Maybe<SuccessResponse>;
  RecipientCreate?: Maybe<SuccessResponse>;
  RecipientDelete?: Maybe<SuccessResponse>;
  RecipientUpdate?: Maybe<SuccessResponse>;
  Register?: Maybe<SuccessResponse>;
  RequestOTP?: Maybe<OtpResponse>;
  ResetPassword?: Maybe<SuccessResponse>;
  ResetPasswordCheck?: Maybe<SuccessResponse>;
  ResetPasswordSendEmail?: Maybe<SuccessResponse>;
  SecureLogin?: Maybe<LoginResponse>;
  UserBasicDetailsUpdate?: Maybe<SuccessResponse>;
  UserCardCreate?: Maybe<SuccessResponse>;
  UserCardDelete?: Maybe<SuccessResponse>;
  UserCardUpdateDefault?: Maybe<SuccessResponse>;
  UserCreate?: Maybe<SuccessResponse>;
  UserDelete?: Maybe<SuccessResponse>;
  UserDeleteCurrentAccount?: Maybe<SuccessResponse>;
  UserProfileImageUpload: SuccessResponse;
  UserUpdate?: Maybe<SuccessResponse>;
  UserUpdatePassword: SuccessResponse;
};

export type MutationCustomerBankAccountUpdateArgs = {
  input?: InputMaybe<CustomerBankAccountUpdateInput>;
};

export type MutationCustomerBankCreateArgs = {
  input?: InputMaybe<CustomerBankCreateInput>;
};

export type MutationCustomerBankUpdateArgs = {
  input?: InputMaybe<CustomerBankUpdateInput>;
};

export type MutationCustomerContactPersonUpdateArgs = {
  input?: InputMaybe<CustomerContactPersonUpdateInput>;
};

export type MutationCustomerCreateArgs = {
  input?: InputMaybe<CustomerCreateInput>;
};

export type MutationCustomerDetailsUpdateArgs = {
  input?: InputMaybe<CustomerDetailsUpdateInput>;
};

export type MutationCustomerProfileUpdateArgs = {
  input?: InputMaybe<CustomerProfileUpdateInput>;
};

export type MutationCustomerRequestApprovalArgs = {
  customer_id?: InputMaybe<Scalars['Int']>;
};

export type MutationCustomerSsmUpdateArgs = {
  input?: InputMaybe<CustomerSsmUpdateInput>;
};

export type MutationCustomerUpdateArgs = {
  input?: InputMaybe<CustomerUpdateInput>;
};

export type MutationCustomerUserCreateArgs = {
  input?: InputMaybe<CustomerUserCreateInput>;
};

export type MutationCustomerUserDeleteArgs = {
  customer_user_id?: InputMaybe<Scalars['Int']>;
};

export type MutationCustomerUserUpdateArgs = {
  input?: InputMaybe<CustomerUserUpdateInput>;
};

export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};

export type MutationMerchantCustomerCreateArgs = {
  input?: InputMaybe<MerchantCustomerCreateInput>;
};

export type MutationMerchantCustomerStatusUpdateArgs = {
  input?: InputMaybe<MerchantCustomerStatusUpdateInput>;
};

export type MutationMerchantCustomerUpdateArgs = {
  input?: InputMaybe<MerchantCustomerUpdateInput>;
};

export type MutationPaymentCancelArgs = {
  payment_id?: InputMaybe<Scalars['Int']>;
};

export type MutationPaymentCreateArgs = {
  input?: InputMaybe<PaymentCreateInput>;
};

export type MutationPaymentLinkCalculateArgs = {
  input?: InputMaybe<PaymentLinkCalculateInput>;
};

export type MutationPaymentLinkCreateArgs = {
  input?: InputMaybe<PaymentLinkCreateInput>;
};

export type MutationPaymentRefundArgs = {
  input?: InputMaybe<PaymentRefundInput>;
};

export type MutationPaymentScheduleCancelArgs = {
  payment_schedule_id?: InputMaybe<Scalars['Int']>;
};

export type MutationPaymentScheduleMakeArgs = {
  payment_schedule_id?: InputMaybe<Scalars['Int']>;
};

export type MutationPaymentScheduleRefundArgs = {
  input?: InputMaybe<PaymentScheduleRefundInput>;
};

export type MutationPaymentUpdateArgs = {
  input?: InputMaybe<PaymentUpdateInput>;
};

export type MutationRecipientCreateArgs = {
  input?: InputMaybe<RecipientCreateInput>;
};

export type MutationRecipientDeleteArgs = {
  recipient_id?: InputMaybe<Scalars['Int']>;
};

export type MutationRecipientUpdateArgs = {
  input?: InputMaybe<RecipientUpdateInput>;
};

export type MutationRegisterArgs = {
  input?: InputMaybe<RegisterInput>;
};

export type MutationRequestOtpArgs = {
  input?: InputMaybe<UserOtpInput>;
};

export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};

export type MutationResetPasswordCheckArgs = {
  token?: InputMaybe<Scalars['String']>;
};

export type MutationResetPasswordSendEmailArgs = {
  user_email: Scalars['String'];
};

export type MutationSecureLoginArgs = {
  input?: InputMaybe<SecureLoginInput>;
};

export type MutationUserBasicDetailsUpdateArgs = {
  input?: InputMaybe<UserBasicDetailsUpdateInput>;
};

export type MutationUserCardCreateArgs = {
  input?: InputMaybe<UserCardCreateInput>;
};

export type MutationUserCardDeleteArgs = {
  user_card_id?: InputMaybe<Scalars['Int']>;
};

export type MutationUserCardUpdateDefaultArgs = {
  input?: InputMaybe<UserCardUpdateDefaultInput>;
};

export type MutationUserCreateArgs = {
  input?: InputMaybe<UserCreateInput>;
};

export type MutationUserDeleteArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type MutationUserDeleteCurrentAccountArgs = {
  reason?: InputMaybe<Scalars['String']>;
};

export type MutationUserProfileImageUploadArgs = {
  user_profile_image?: InputMaybe<Scalars['Upload']>;
};

export type MutationUserUpdateArgs = {
  input?: InputMaybe<UserUpdateInput>;
};

export type MutationUserUpdatePasswordArgs = {
  input?: InputMaybe<UserUpdatePasswordInput>;
};

export type OtpResponse = {
  __typename?: 'OTPResponse';
  message?: Maybe<Scalars['String']>;
  otp_no?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM',
}

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type Payment = {
  __typename?: 'Payment';
  customer?: Maybe<Customer>;
  is_payment_repeat?: Maybe<Scalars['Boolean']>;
  is_refund_requested?: Maybe<Scalars['Boolean']>;
  is_repeated?: Maybe<Scalars['Boolean']>;
  payment_amount?: Maybe<Scalars['Float']>;
  payment_amount_total?: Maybe<Scalars['Float']>;
  payment_complete_date?: Maybe<Scalars['Date']>;
  payment_complete_media?: Maybe<Array<Maybe<Media>>>;
  payment_created?: Maybe<Scalars['DateTime']>;
  payment_end_date?: Maybe<Scalars['Date']>;
  payment_extra_charges?: Maybe<Scalars['Float']>;
  payment_extra_charges_rate?: Maybe<Scalars['Float']>;
  payment_extra_charges_total?: Maybe<Scalars['Float']>;
  payment_extra_charges_type?: Maybe<Scalars['String']>;
  payment_grandtotal?: Maybe<Scalars['Float']>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_log?: Maybe<Array<Maybe<PaymentLog>>>;
  payment_recipient?: Maybe<Array<Maybe<PaymentRecipientDetails>>>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_referer_code?: Maybe<Scalars['String']>;
  payment_repeat_type?: Maybe<PaymentRepeatType>;
  payment_schedule?: Maybe<Array<Maybe<PaymentSchedule>>>;
  payment_schedule_number_current?: Maybe<Scalars['Int']>;
  payment_schedule_total_number?: Maybe<Scalars['Int']>;
  payment_start_date?: Maybe<Scalars['Date']>;
  payment_status?: Maybe<PaymentStatus>;
  payment_subtotal?: Maybe<Scalars['Float']>;
  payment_supporting_media?: Maybe<Array<Maybe<Media>>>;
  payment_type?: Maybe<PaymentType>;
  payment_updated?: Maybe<Scalars['DateTime']>;
  user_card?: Maybe<UserCard>;
};

export type PaymentCalculation = {
  __typename?: 'PaymentCalculation';
  payment_amount?: Maybe<Scalars['Float']>;
  payment_extra_charges?: Maybe<Scalars['Float']>;
  payment_extra_charges_rate?: Maybe<Scalars['Float']>;
  payment_grandtotal?: Maybe<Scalars['Float']>;
  payment_standard_fee_rate?: Maybe<Scalars['Float']>;
  payment_subtotal?: Maybe<Scalars['Float']>;
};

export type PaymentCreateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  payment_amount?: InputMaybe<Scalars['Float']>;
  payment_meta_json?: InputMaybe<Scalars['Json']>;
  payment_reference?: InputMaybe<Scalars['String']>;
  payment_repeat_type_id?: InputMaybe<Scalars['Int']>;
  payment_schedule_total_number?: InputMaybe<Scalars['Int']>;
  payment_start_date?: InputMaybe<Scalars['Date']>;
  payment_supporting_media?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  payment_type_id?: InputMaybe<Scalars['Int']>;
  recipient?: InputMaybe<Array<InputMaybe<PaymentRecipientInput>>>;
  user_card_id?: InputMaybe<Scalars['Int']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  customer?: Maybe<Customer>;
  is_payment_repeat?: Maybe<Scalars['Boolean']>;
  is_repeated?: Maybe<Scalars['Boolean']>;
  payment_amount?: Maybe<Scalars['Float']>;
  payment_amount_total?: Maybe<Scalars['Float']>;
  payment_complete_date?: Maybe<Scalars['Date']>;
  payment_complete_media?: Maybe<Array<Maybe<Media>>>;
  payment_created?: Maybe<Scalars['DateTime']>;
  payment_end_date?: Maybe<Scalars['Date']>;
  payment_extra_charges?: Maybe<Scalars['Float']>;
  payment_extra_charges_rate?: Maybe<Scalars['Float']>;
  payment_extra_charges_total?: Maybe<Scalars['Float']>;
  payment_extra_charges_type?: Maybe<Scalars['String']>;
  payment_grandtotal?: Maybe<Scalars['Float']>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_recipient?: Maybe<Array<Maybe<PaymentRecipientDetails>>>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_referer_code?: Maybe<Scalars['String']>;
  payment_reject_details?: Maybe<PaymentLog>;
  payment_repeat_type?: Maybe<PaymentRepeatType>;
  payment_schedule?: Maybe<Array<Maybe<PaymentSchedule>>>;
  payment_schedule_number_current?: Maybe<Scalars['Int']>;
  payment_schedule_total_number?: Maybe<Scalars['Int']>;
  payment_start_date?: Maybe<Scalars['Date']>;
  payment_status?: Maybe<PaymentStatus>;
  payment_subtotal?: Maybe<Scalars['Float']>;
  payment_supporting_media?: Maybe<Array<Maybe<Media>>>;
  payment_type?: Maybe<PaymentType>;
  payment_updated?: Maybe<Scalars['DateTime']>;
  user_card?: Maybe<UserCard>;
};

export enum PaymentExtraChargesType {
  Amount = 'Amount',
  Percentage = 'Percentage',
  Standard = 'Standard',
}

export enum PaymentGroupStatus {
  All = 'All',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Draft = 'Draft',
  Failed = 'Failed',
  OnTheWay = 'On_the_way',
  Rejected = 'Rejected',
  Scheduled = 'Scheduled',
}

export type PaymentGroupStatusCount = {
  __typename?: 'PaymentGroupStatusCount';
  count?: Maybe<Scalars['Int']>;
  payment_group_status?: Maybe<Scalars['String']>;
};

export type PaymentLessDetail = {
  __typename?: 'PaymentLessDetail';
  payment_end_date?: Maybe<Scalars['Date']>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_status?: Maybe<PaymentStatus>;
  recipients?: Maybe<Array<Maybe<RecipientLessDetail>>>;
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  customer?: Maybe<Customer>;
  is_payment_repeat?: Maybe<Scalars['Boolean']>;
  is_refund_requested?: Maybe<Scalars['Boolean']>;
  is_repeated?: Maybe<Scalars['Boolean']>;
  merchant_customer?: Maybe<MerchantCustomer>;
  paid_by?: Maybe<PaymentLinkPaidBy>;
  payment_amount?: Maybe<Scalars['Float']>;
  payment_amount_total?: Maybe<Scalars['Float']>;
  payment_complete_media?: Maybe<Array<Maybe<Media>>>;
  payment_created?: Maybe<Scalars['DateTime']>;
  payment_expired_date?: Maybe<Scalars['Date']>;
  payment_extra_charges?: Maybe<Scalars['Float']>;
  payment_extra_charges_rate?: Maybe<Scalars['Float']>;
  payment_extra_charges_total?: Maybe<Scalars['Float']>;
  payment_extra_charges_type?: Maybe<Scalars['String']>;
  payment_grandtotal?: Maybe<Scalars['Float']>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_link?: Maybe<Scalars['String']>;
  payment_log?: Maybe<Array<Maybe<PaymentLog>>>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_referer_code?: Maybe<Scalars['String']>;
  payment_schedule_number_current?: Maybe<Scalars['Int']>;
  payment_status?: Maybe<PaymentStatus>;
  payment_subtotal?: Maybe<Scalars['Float']>;
  payment_updated?: Maybe<Scalars['DateTime']>;
};

export type PaymentLinkCalculateInput = {
  paid_by?: InputMaybe<PaymentLinkPaidBy>;
  payment_amount?: InputMaybe<Scalars['Float']>;
};

export type PaymentLinkCreateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  merchant_customer_id?: InputMaybe<Scalars['Int']>;
  paid_by?: InputMaybe<PaymentLinkPaidBy>;
  payment_amount?: InputMaybe<Scalars['Float']>;
  payment_expired_date?: InputMaybe<Scalars['Date']>;
  payment_extra_charges?: InputMaybe<Scalars['Float']>;
  payment_extra_charges_rate?: InputMaybe<Scalars['Float']>;
  payment_grandtotal?: InputMaybe<Scalars['Float']>;
  payment_reference?: InputMaybe<Scalars['String']>;
  payment_standard_rate?: InputMaybe<Scalars['Float']>;
  payment_subtotal?: InputMaybe<Scalars['Float']>;
};

export type PaymentLinkListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  merchant_customer_id?: InputMaybe<Scalars['Int']>;
  payment_end_date?: InputMaybe<Scalars['Date']>;
  payment_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  payment_start_date?: InputMaybe<Scalars['Date']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_status_id?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<PaymentSortBy>;
  sort_order?: InputMaybe<SortOrder>;
};

/** A paginated list of PaymentLink items. */
export type PaymentLinkPaginator = {
  __typename?: 'PaymentLinkPaginator';
  /** A list of PaymentLink items. */
  data: Array<PaymentLink>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum PaymentLinkPaidBy {
  Customer = 'customer',
  Me = 'me',
}

export type PaymentLinkStatusCount = {
  __typename?: 'PaymentLinkStatusCount';
  count?: Maybe<Scalars['Int']>;
  payment_status?: Maybe<Scalars['String']>;
};

export type PaymentListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  is_payment_repeat?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  payment_end_date?: InputMaybe<Scalars['Date']>;
  payment_group_status?: InputMaybe<Scalars['String']>;
  payment_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  payment_repeat_type_id?: InputMaybe<Scalars['Int']>;
  payment_start_date?: InputMaybe<Scalars['Date']>;
  payment_status_id?: InputMaybe<Scalars['Int']>;
  payment_type_id?: InputMaybe<Scalars['Int']>;
  recipient_id?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<PaymentSortBy>;
  sort_order?: InputMaybe<SortOrder>;
};

export type PaymentLog = {
  __typename?: 'PaymentLog';
  payment_id?: Maybe<Scalars['Int']>;
  payment_log_action?: Maybe<Scalars['String']>;
  payment_log_created?: Maybe<Scalars['DateTime']>;
  payment_log_description?: Maybe<Scalars['String']>;
  payment_log_id?: Maybe<Scalars['Int']>;
  payment_log_remark?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<RejectReason>;
  user?: Maybe<User>;
};

export type PaymentMake = {
  __typename?: 'PaymentMake';
  payment?: Maybe<Payment>;
  payment_number?: Maybe<Scalars['String']>;
  payment_url?: Maybe<Scalars['String']>;
};

export type PaymentOverviewData = {
  __typename?: 'PaymentOverviewData';
  payment_status_name?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** A paginated list of Payment items. */
export type PaymentPaginator = {
  __typename?: 'PaymentPaginator';
  /** A list of Payment items. */
  data: Array<Payment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PaymentRecipient = {
  __typename?: 'PaymentRecipient';
  bank_id?: Maybe<Scalars['Int']>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_recipient_account_name?: Maybe<Scalars['String']>;
  payment_recipient_account_number?: Maybe<Scalars['String']>;
  payment_recipient_amount?: Maybe<Scalars['Float']>;
  payment_recipient_id?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
};

export type PaymentRecipientDetails = {
  __typename?: 'PaymentRecipientDetails';
  bank_id?: Maybe<Scalars['Int']>;
  payment?: Maybe<Payment>;
  payment_recipient_account_name?: Maybe<Scalars['String']>;
  payment_recipient_account_number?: Maybe<Scalars['String']>;
  payment_recipient_amount?: Maybe<Scalars['Float']>;
  payment_recipient_id?: Maybe<Scalars['Int']>;
  recipient?: Maybe<Recipient>;
};

export type PaymentRecipientInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  payment_recipient_account_name?: InputMaybe<Scalars['String']>;
  payment_recipient_account_number?: InputMaybe<Scalars['String']>;
  payment_recipient_amount?: InputMaybe<Scalars['Float']>;
  payment_recipient_email?: InputMaybe<Scalars['String']>;
  payment_recipient_mobile_number?: InputMaybe<Scalars['String']>;
  recipient_id?: InputMaybe<Scalars['Int']>;
};

export type PaymentRecipientListing = {
  __typename?: 'PaymentRecipientListing';
  bank_id?: Maybe<Scalars['Int']>;
  payment?: Maybe<Payment>;
  payment_recipient_account_name?: Maybe<Scalars['String']>;
  payment_recipient_account_number?: Maybe<Scalars['String']>;
  payment_recipient_amount?: Maybe<Scalars['Float']>;
  payment_recipient_id?: Maybe<Scalars['Int']>;
  recipient?: Maybe<Recipient>;
};

export type PaymentRefundInput = {
  payment_id?: InputMaybe<Scalars['Int']>;
  refund_reason?: InputMaybe<Scalars['String']>;
};

export type PaymentRepeatType = {
  __typename?: 'PaymentRepeatType';
  is_deleted?: Maybe<Scalars['Int']>;
  is_disabled?: Maybe<Scalars['Boolean']>;
  is_display?: Maybe<Scalars['Boolean']>;
  is_extra_charges?: Maybe<Scalars['Boolean']>;
  payment_repeat_type_additional_days?: Maybe<Scalars['Int']>;
  payment_repeat_type_category?: Maybe<PaymentRepeatTypeCategory>;
  payment_repeat_type_charges_rate?: Maybe<Scalars['Float']>;
  payment_repeat_type_charges_type?: Maybe<PaymentRepeatTypeChargesType>;
  payment_repeat_type_id?: Maybe<Scalars['Int']>;
  payment_repeat_type_name?: Maybe<Scalars['Json']>;
  payment_repeat_type_parent_id?: Maybe<Scalars['Int']>;
  standard_fee?: Maybe<Scalars['Float']>;
};

export enum PaymentRepeatTypeCategory {
  Repeat = 'Repeat',
  Standard = 'Standard',
}

export enum PaymentRepeatTypeChargesType {
  Amount = 'Amount',
  Percentage = 'Percentage',
}

export type PaymentRepeatTypeDropdown = {
  __typename?: 'PaymentRepeatTypeDropdown';
  is_extra_charges?: Maybe<Scalars['Boolean']>;
  payment_repeat_type_additional_days?: Maybe<Scalars['Int']>;
  payment_repeat_type_category?: Maybe<Scalars['String']>;
  payment_repeat_type_charges_rate?: Maybe<Scalars['Float']>;
  payment_repeat_type_charges_type?: Maybe<Scalars['String']>;
  payment_repeat_type_id?: Maybe<Scalars['Int']>;
  payment_repeat_type_name?: Maybe<Scalars['Json']>;
  standard_fee?: Maybe<Scalars['Float']>;
};

export type PaymentRepeatTypeListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  payment_repeat_type_category?: InputMaybe<PaymentRepeatTypeCategory>;
  payment_repeat_type_charges_type?: InputMaybe<PaymentRepeatTypeChargesType>;
  payment_repeat_type_id?: InputMaybe<Scalars['Int']>;
};

/** A paginated list of PaymentRepeatType items. */
export type PaymentRepeatTypePaginator = {
  __typename?: 'PaymentRepeatTypePaginator';
  /** A list of PaymentRepeatType items. */
  data: Array<PaymentRepeatType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PaymentReportData = {
  __typename?: 'PaymentReportData';
  data?: Maybe<Scalars['Json']>;
  payment_type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type PaymentSchedule = {
  __typename?: 'PaymentSchedule';
  customer?: Maybe<Customer>;
  is_refund_requested?: Maybe<Scalars['Boolean']>;
  payment?: Maybe<Payment>;
  payment_recipient?: Maybe<Array<Maybe<PaymentRecipientDetails>>>;
  payment_repeat_type?: Maybe<PaymentRepeatType>;
  payment_schedule_amount?: Maybe<Scalars['Float']>;
  payment_schedule_complete_date?: Maybe<Scalars['Date']>;
  payment_schedule_complete_media?: Maybe<Array<Maybe<Media>>>;
  payment_schedule_created?: Maybe<Scalars['DateTime']>;
  payment_schedule_date?: Maybe<Scalars['Date']>;
  payment_schedule_id?: Maybe<Scalars['Int']>;
  payment_schedule_log?: Maybe<Array<Maybe<PaymentScheduleLog>>>;
  payment_schedule_number?: Maybe<Scalars['Int']>;
  payment_schedule_referer_code?: Maybe<Scalars['String']>;
  payment_schedule_refund?: Maybe<Array<Maybe<PaymentScheduleRefund>>>;
  payment_schedule_updated?: Maybe<Scalars['DateTime']>;
  payment_status?: Maybe<PaymentStatus>;
  user_card?: Maybe<UserCard>;
};

export type PaymentScheduleListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['Date']>;
  is_payment_repeat?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  payment_repeat_type_id?: InputMaybe<Scalars['Int']>;
  payment_schedule_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  payment_status_id?: InputMaybe<Scalars['Int']>;
  recipient_id?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<PaymentScheduleSortBy>;
  sort_order?: InputMaybe<SortOrder>;
  start_date?: InputMaybe<Scalars['Date']>;
};

export type PaymentScheduleLog = {
  __typename?: 'PaymentScheduleLog';
  admin?: Maybe<User>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_schedule_id?: Maybe<Scalars['Int']>;
  payment_schedule_log_action?: Maybe<Scalars['String']>;
  payment_schedule_log_created?: Maybe<Scalars['DateTime']>;
  payment_schedule_log_description?: Maybe<Scalars['String']>;
  payment_schedule_log_id?: Maybe<Scalars['Int']>;
  payment_schedule_log_updated?: Maybe<Scalars['DateTime']>;
};

/** A paginated list of PaymentSchedule items. */
export type PaymentSchedulePaginator = {
  __typename?: 'PaymentSchedulePaginator';
  /** A list of PaymentSchedule items. */
  data: Array<PaymentSchedule>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PaymentScheduleRefund = {
  __typename?: 'PaymentScheduleRefund';
  payment_schedule_id?: Maybe<Scalars['Int']>;
  refund_reason?: Maybe<Scalars['String']>;
  refund_request_created?: Maybe<Scalars['DateTime']>;
  refund_request_status?: Maybe<RefundRequestStatus>;
  reject_reason?: Maybe<Scalars['String']>;
};

export type PaymentScheduleRefundInput = {
  payment_schedule_id?: InputMaybe<Scalars['Int']>;
  refund_reason?: InputMaybe<Scalars['String']>;
};

export type PaymentScheduleRefundListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['Date']>;
  is_payment_repeat?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  payment_repeat_type_id?: InputMaybe<Scalars['Int']>;
  payment_schedule_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  recipient_id?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<PaymentScheduleSortBy>;
  sort_order?: InputMaybe<SortOrder>;
  start_date?: InputMaybe<Scalars['Date']>;
};

export enum PaymentScheduleSortBy {
  PaymentScheduleCompleteDate = 'payment_schedule_complete_date',
  PaymentScheduleCreated = 'payment_schedule_created',
  PaymentScheduleDate = 'payment_schedule_date',
  PaymentScheduleUpdated = 'payment_schedule_updated',
}

export enum PaymentSortBy {
  PaymentCreated = 'payment_created',
  PaymentEndDate = 'payment_end_date',
  PaymentStartDate = 'payment_start_date',
  PaymentUpdated = 'payment_updated',
}

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  payment_status_desc?: Maybe<Scalars['String']>;
  payment_status_id?: Maybe<Scalars['Int']>;
  payment_status_name?: Maybe<Scalars['String']>;
};

export type PaymentStatusCount = {
  __typename?: 'PaymentStatusCount';
  count?: Maybe<Scalars['Int']>;
  payment_status_id?: Maybe<Scalars['Int']>;
  payment_status_name?: Maybe<Scalars['String']>;
};

export type PaymentStatusInput = {
  keyword?: InputMaybe<Scalars['String']>;
};

/** A paginated list of PaymentStatus items. */
export type PaymentStatusPaginator = {
  __typename?: 'PaymentStatusPaginator';
  /** A list of PaymentStatus items. */
  data: Array<PaymentStatus>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  is_allowed_payment_repeat?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  payment_type_created?: Maybe<Scalars['DateTime']>;
  payment_type_document?: Maybe<Scalars['String']>;
  payment_type_id?: Maybe<Scalars['Int']>;
  payment_type_name?: Maybe<Scalars['Json']>;
  payment_type_updated?: Maybe<Scalars['DateTime']>;
};

export type PaymentTypeDropdown = {
  __typename?: 'PaymentTypeDropdown';
  is_allowed_payment_repeat?: Maybe<Scalars['Boolean']>;
  payment_type_document?: Maybe<Scalars['String']>;
  payment_type_id?: Maybe<Scalars['Int']>;
  payment_type_name?: Maybe<Scalars['Json']>;
};

export type PaymentTypeListingInput = {
  is_allowed_payment_repeat?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
};

/** A paginated list of PaymentType items. */
export type PaymentTypePaginator = {
  __typename?: 'PaymentTypePaginator';
  /** A list of PaymentType items. */
  data: Array<PaymentType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PaymentUpdateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  payment_amount?: InputMaybe<Scalars['Float']>;
  payment_id?: InputMaybe<Scalars['Int']>;
  payment_meta_json?: InputMaybe<Scalars['Json']>;
  payment_reference?: InputMaybe<Scalars['String']>;
  payment_repeat_type_id?: InputMaybe<Scalars['Int']>;
  payment_schedule_total_number?: InputMaybe<Scalars['Int']>;
  payment_start_date?: InputMaybe<Scalars['Date']>;
  payment_supporting_media?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  payment_type_id?: InputMaybe<Scalars['Int']>;
  recipient?: InputMaybe<Array<InputMaybe<PaymentRecipientInput>>>;
  user_card_id?: InputMaybe<Scalars['Int']>;
};

export type Permission = {
  __typename?: 'Permission';
  display_name?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_type_id?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  AnnualRevenueDropdown?: Maybe<Array<Maybe<AnnualRevenue>>>;
  BankDropdown?: Maybe<Array<Maybe<Bank>>>;
  BankNameSearch?: Maybe<Bank>;
  BusinessTypeDropdown?: Maybe<Array<Maybe<BusinessType>>>;
  BusinessTypeListing?: Maybe<BusinessTypePaginator>;
  BusinessYearDropdown?: Maybe<Array<Maybe<BusinessYear>>>;
  BusinessYearListing?: Maybe<BusinessYearPaginator>;
  CityDropdown?: Maybe<Array<Maybe<City>>>;
  CompanySizeDropdown?: Maybe<Array<Maybe<CompanySize>>>;
  CountryDropdown?: Maybe<Array<Maybe<Country>>>;
  CustomerDetail?: Maybe<CustomerFullDetail>;
  CustomerLogDetail?: Maybe<CustomerLog>;
  CustomerQuestionDetail?: Maybe<CustomerQuestion>;
  CustomerUserDetail?: Maybe<CustomerUser>;
  CustomerUserListing?: Maybe<CustomerUserPaginator>;
  DashboardMerchant?: Maybe<DashboardMerchantStatus>;
  Me?: Maybe<User>;
  MerchantCustomerDetail?: Maybe<MerchantCustomer>;
  MerchantCustomerDropdown?: Maybe<Array<Maybe<MerchantCustomerDropdown>>>;
  MerchantCustomerListing?: Maybe<MerchantCustomerPaginator>;
  MerchantCustomerStatusCount?: Maybe<
    Array<Maybe<MerchantCustomerStatusCount>>
  >;
  PaymentDetail?: Maybe<PaymentDetails>;
  PaymentGroupListingStatusCount?: Maybe<Array<Maybe<PaymentGroupStatusCount>>>;
  PaymentLinkDetail?: Maybe<PaymentLink>;
  PaymentLinkListing?: Maybe<PaymentLinkPaginator>;
  PaymentLinkMake?: Maybe<PaymentMake>;
  PaymentLinkReference?: Maybe<PaymentLink>;
  PaymentLinkStatusCount?: Maybe<Array<Maybe<PaymentLinkStatusCount>>>;
  PaymentListing?: Maybe<PaymentPaginator>;
  PaymentListingExport?: Maybe<SuccessResponse>;
  PaymentListingStatusCount?: Maybe<Array<Maybe<PaymentStatusCount>>>;
  PaymentMake?: Maybe<PaymentMake>;
  PaymentReleaseListingExport?: Maybe<SuccessResponse>;
  PaymentRepeatTypeDropdown?: Maybe<Array<Maybe<PaymentRepeatTypeDropdown>>>;
  PaymentRepeatTypeListing?: Maybe<PaymentRepeatTypePaginator>;
  PaymentRequestListingExport?: Maybe<SuccessResponse>;
  PaymentScheduleListing?: Maybe<PaymentSchedulePaginator>;
  PaymentScheduleListingExport?: Maybe<SuccessResponse>;
  PaymentScheduleListingStatusCount?: Maybe<Array<Maybe<PaymentStatusCount>>>;
  PaymentScheduleRefundListing?: Maybe<PaymentSchedulePaginator>;
  PaymentStatusDropdown?: Maybe<Array<Maybe<PaymentStatus>>>;
  PaymentStatusListing?: Maybe<PaymentStatusPaginator>;
  PaymentTypeDetail?: Maybe<PaymentType>;
  PaymentTypeDropdown?: Maybe<Array<Maybe<PaymentTypeDropdown>>>;
  PaymentTypeListing?: Maybe<PaymentTypePaginator>;
  QuestionListing?: Maybe<QuestionPaginator>;
  RecipientCategoryDropdown?: Maybe<Array<Maybe<RecipientCategory>>>;
  RecipientDetail?: Maybe<Recipient>;
  RecipientListing?: Maybe<RecipientListingPaginator>;
  RecipientListingDropdown?: Maybe<Array<Maybe<Recipient>>>;
  RecipientListingExport?: Maybe<SuccessResponse>;
  RejectReasonDropdown?: Maybe<Array<Maybe<RejectReason>>>;
  SettingDetail?: Maybe<Setting>;
  SettingDetails?: Maybe<Scalars['Json']>;
  StateDropdown?: Maybe<Array<Maybe<State>>>;
  UserCardDropdown?: Maybe<Array<Maybe<UserCardDropdown>>>;
  UserCardListing?: Maybe<UserCardListingPaginator>;
  UserDetail?: Maybe<User>;
  UserListing?: Maybe<UserListingPaginator>;
};

export type QueryBankNameSearchArgs = {
  bank_name: Scalars['String'];
};

export type QueryBusinessTypeListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryBusinessYearListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryCityDropdownArgs = {
  state_id?: InputMaybe<Scalars['Int']>;
};

export type QueryCustomerDetailArgs = {
  customer_id?: InputMaybe<Scalars['Int']>;
};

export type QueryCustomerLogDetailArgs = {
  customer_log_id?: InputMaybe<Scalars['Int']>;
};

export type QueryCustomerQuestionDetailArgs = {
  customer_question_id?: InputMaybe<Scalars['Int']>;
};

export type QueryCustomerUserDetailArgs = {
  customer_user_id?: InputMaybe<Scalars['Int']>;
};

export type QueryCustomerUserListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<CustomerUserListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryMerchantCustomerDetailArgs = {
  merchant_customer_id?: InputMaybe<Scalars['Int']>;
};

export type QueryMerchantCustomerListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<MerchantCustomerListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryMerchantCustomerStatusCountArgs = {
  input?: InputMaybe<MerchantCustomerListingInput>;
};

export type QueryPaymentDetailArgs = {
  payment_id?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentGroupListingStatusCountArgs = {
  input?: InputMaybe<PaymentListingInput>;
};

export type QueryPaymentLinkDetailArgs = {
  payment_id?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentLinkListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentLinkListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentLinkMakeArgs = {
  payment_id?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentLinkReferenceArgs = {
  payment_referer_code?: InputMaybe<Scalars['String']>;
};

export type QueryPaymentLinkStatusCountArgs = {
  input?: InputMaybe<PaymentLinkListingInput>;
};

export type QueryPaymentListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentListingExportArgs = {
  input?: InputMaybe<PaymentListingInput>;
};

export type QueryPaymentListingStatusCountArgs = {
  input?: InputMaybe<PaymentListingInput>;
};

export type QueryPaymentMakeArgs = {
  payment_id?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentReleaseListingExportArgs = {
  input?: InputMaybe<PaymentScheduleListingInput>;
};

export type QueryPaymentRepeatTypeDropdownArgs = {
  payment_repeat_type_category?: InputMaybe<PaymentRepeatTypeCategory>;
};

export type QueryPaymentRepeatTypeListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentRepeatTypeListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentRequestListingExportArgs = {
  input?: InputMaybe<PaymentListingInput>;
};

export type QueryPaymentScheduleListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentScheduleListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentScheduleListingExportArgs = {
  input?: InputMaybe<PaymentScheduleListingInput>;
};

export type QueryPaymentScheduleListingStatusCountArgs = {
  input?: InputMaybe<PaymentScheduleListingInput>;
};

export type QueryPaymentScheduleRefundListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentScheduleListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentStatusListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentStatusInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentTypeDetailArgs = {
  payment_type_id?: InputMaybe<Scalars['Int']>;
};

export type QueryPaymentTypeListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<PaymentTypeListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryQuestionListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<QuestionListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryRecipientDetailArgs = {
  recipient_id?: InputMaybe<Scalars['Int']>;
};

export type QueryRecipientListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<RecipientListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryRecipientListingExportArgs = {
  input?: InputMaybe<RecipientListingInput>;
};

export type QueryRejectReasonDropdownArgs = {
  reject_reason_type?: InputMaybe<RejectReasonType>;
};

export type QuerySettingDetailArgs = {
  setting_slug?: InputMaybe<Scalars['String']>;
};

export type QuerySettingDetailsArgs = {
  setting_slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryStateDropdownArgs = {
  country_id?: InputMaybe<Scalars['Int']>;
};

export type QueryUserCardListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<UserCardListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryUserDetailArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type QueryUserListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<UserListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Question = {
  __typename?: 'Question';
  question_id: Scalars['Int'];
  question_priority?: Maybe<Scalars['Int']>;
  question_section?: Maybe<Scalars['Int']>;
  question_status?: Maybe<QuestionStatus>;
  question_title?: Maybe<Scalars['String']>;
  question_type?: Maybe<Scalars['String']>;
  question_value?: Maybe<Scalars['Json']>;
  question_value_column?: Maybe<Scalars['Int']>;
};

export type QuestionListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  question_priority?: InputMaybe<Scalars['Int']>;
  question_section?: InputMaybe<Scalars['Int']>;
  question_type?: InputMaybe<QuestionType>;
};

/** A paginated list of Question items. */
export type QuestionPaginator = {
  __typename?: 'QuestionPaginator';
  /** A list of Question items. */
  data: Array<Question>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum QuestionStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum QuestionType {
  /** Multi-select */
  MultiSelect = 'MULTI_SELECT',
  /** Single-select */
  SingleSelect = 'SINGLE_SELECT',
}

export type Recipient = {
  __typename?: 'Recipient';
  bank?: Maybe<Bank>;
  country?: Maybe<Country>;
  customer?: Maybe<Customer>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_notify?: Maybe<Scalars['Boolean']>;
  recipient_bank_account_number?: Maybe<Scalars['String']>;
  recipient_bank_holder_name?: Maybe<Scalars['String']>;
  recipient_category?: Maybe<RecipientCategory>;
  recipient_created?: Maybe<Scalars['DateTime']>;
  recipient_email?: Maybe<Scalars['String']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_mobile_number?: Maybe<Scalars['String']>;
  recipient_status?: Maybe<RecipientStatus>;
  recipient_type?: Maybe<RecipientType>;
  recipient_updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type RecipientCategory = {
  __typename?: 'RecipientCategory';
  is_deleted?: Maybe<Scalars['Boolean']>;
  recipient_category_badge_colour?: Maybe<Scalars['String']>;
  recipient_category_created?: Maybe<Scalars['DateTime']>;
  recipient_category_id?: Maybe<Scalars['Int']>;
  recipient_category_name?: Maybe<Scalars['String']>;
  recipient_category_updated?: Maybe<Scalars['DateTime']>;
};

export type RecipientCreateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  is_notifiy?: InputMaybe<Scalars['Boolean']>;
  recipient_bank_account_number?: InputMaybe<Scalars['String']>;
  recipient_bank_holder_name?: InputMaybe<Scalars['String']>;
  recipient_category_id?: InputMaybe<Scalars['Int']>;
  recipient_email?: InputMaybe<Scalars['String']>;
  recipient_mobile_number?: InputMaybe<Scalars['String']>;
  recipient_status?: InputMaybe<RecipientStatus>;
  recipient_type?: InputMaybe<RecipientType>;
};

export type RecipientLessDetail = {
  __typename?: 'RecipientLessDetail';
  bank?: Maybe<Bank>;
  country?: Maybe<Country>;
  recipient_bank_account_number?: Maybe<Scalars['String']>;
  recipient_bank_holder_name?: Maybe<Scalars['String']>;
  recipient_email?: Maybe<Scalars['String']>;
  recipient_id?: Maybe<Scalars['Int']>;
};

export type RecipientListing = {
  __typename?: 'RecipientListing';
  bank?: Maybe<Bank>;
  country?: Maybe<Country>;
  customer?: Maybe<Customer>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_notify?: Maybe<Scalars['Boolean']>;
  recipient_bank_account_number?: Maybe<Scalars['String']>;
  recipient_bank_holder_name?: Maybe<Scalars['String']>;
  recipient_category?: Maybe<RecipientCategory>;
  recipient_created?: Maybe<Scalars['DateTime']>;
  recipient_email?: Maybe<Scalars['String']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_mobile_number?: Maybe<Scalars['String']>;
  recipient_status?: Maybe<RecipientStatus>;
  recipient_type?: Maybe<RecipientType>;
  recipient_updated?: Maybe<Scalars['DateTime']>;
  total_amount?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
};

export type RecipientListingInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  country_currency_code?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  recipient_category_id?: InputMaybe<Scalars['Int']>;
  recipient_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  recipient_type?: InputMaybe<RecipientType>;
};

/** A paginated list of RecipientListing items. */
export type RecipientListingPaginator = {
  __typename?: 'RecipientListingPaginator';
  /** A list of RecipientListing items. */
  data: Array<RecipientListing>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum RecipientStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum RecipientType {
  Company = 'Company',
  Personal = 'Personal',
}

export type RecipientUpdateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  recipient_bank_account_number?: InputMaybe<Scalars['String']>;
  recipient_bank_holder_name?: InputMaybe<Scalars['String']>;
  recipient_category_id?: InputMaybe<Scalars['Int']>;
  recipient_email?: InputMaybe<Scalars['String']>;
  recipient_id?: InputMaybe<Scalars['Int']>;
  recipient_mobile_number?: InputMaybe<Scalars['String']>;
  recipient_status?: InputMaybe<RecipientStatus>;
  recipient_type?: InputMaybe<RecipientType>;
};

export enum RefundRequestStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
}

export type RegisterInput = {
  device_id: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  otp_no: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  user_email: Scalars['String'];
  user_mobile: Scalars['String'];
  username: Scalars['String'];
};

export type RejectReason = {
  __typename?: 'RejectReason';
  is_deleted?: Maybe<Scalars['Boolean']>;
  reject_reason_description?: Maybe<Scalars['String']>;
  reject_reason_id?: Maybe<Scalars['Int']>;
  reject_reason_name?: Maybe<Scalars['String']>;
  reject_reason_type?: Maybe<Scalars['String']>;
};

export enum RejectReasonType {
  Application = 'Application',
  Payment = 'Payment',
}

export type ReportInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  customer_name?: InputMaybe<Scalars['String']>;
  payment_type_id?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['String']>;
};

export type ReportPaginator = {
  __typename?: 'ReportPaginator';
  data?: Maybe<PaymentReportData>;
  paginatorInfo?: Maybe<PaginatorInfo>;
};

export type ResetPasswordInput = {
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type SecureLoginInput = {
  device_id: Scalars['String'];
  otp_no?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  user_mobile: Scalars['String'];
};

export type Setting = {
  __typename?: 'Setting';
  is_editable?: Maybe<Scalars['Int']>;
  setting_description?: Maybe<Scalars['String']>;
  setting_id?: Maybe<Scalars['Int']>;
  setting_media?: Maybe<Media>;
  setting_slug?: Maybe<Scalars['String']>;
  setting_value?: Maybe<Scalars['String']>;
};

export enum SettingStatus {
  Draft = 'draft',
  Publish = 'publish',
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC',
}

export type SpendingAllocation = {
  __typename?: 'SpendingAllocation';
  data?: Maybe<Array<Maybe<SpendingAllocationData>>>;
  title?: Maybe<Scalars['String']>;
};

export type SpendingAllocationData = {
  __typename?: 'SpendingAllocationData';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
  payment_type_name?: Maybe<Scalars['String']>;
  weightage?: Maybe<Scalars['Float']>;
};

export type State = {
  __typename?: 'State';
  city?: Maybe<Array<Maybe<City>>>;
  country?: Maybe<Country>;
  is_deleted?: Maybe<Scalars['Int']>;
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  token?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT',
}

export type User = {
  __typename?: 'User';
  customer?: Maybe<Customer>;
  email_verified_at?: Maybe<Scalars['DateTime']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  user_address?: Maybe<Scalars['String']>;
  user_address2?: Maybe<Scalars['String']>;
  user_alternative_email?: Maybe<Scalars['String']>;
  user_alternative_mobile?: Maybe<Scalars['String']>;
  user_city?: Maybe<City>;
  user_code?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['DateTime']>;
  user_dob?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_gender?: Maybe<UserGender>;
  user_id?: Maybe<Scalars['Int']>;
  user_ip?: Maybe<Scalars['String']>;
  user_join_date?: Maybe<Scalars['Date']>;
  user_language?: Maybe<Scalars['String']>;
  user_logindate?: Maybe<Scalars['DateTime']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_mobile_verified?: Maybe<Scalars['Boolean']>;
  user_nationality?: Maybe<Country>;
  user_nric?: Maybe<Scalars['String']>;
  user_permissions?: Maybe<Array<Maybe<Permission>>>;
  user_postcode?: Maybe<Scalars['String']>;
  user_profile_image?: Maybe<Images>;
  user_role?: Maybe<Role>;
  user_state?: Maybe<State>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_updated?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type UserBasicDetailsUpdateInput = {
  user_email: Scalars['String'];
  user_fullname: Scalars['String'];
  user_id: Scalars['Int'];
  user_mobile: Scalars['String'];
};

export type UserCard = {
  __typename?: 'UserCard';
  is_default_card?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  user_card_cardholder_name?: Maybe<Scalars['String']>;
  user_card_created?: Maybe<Scalars['DateTime']>;
  user_card_expiration_month?: Maybe<Scalars['Int']>;
  user_card_expiration_year?: Maybe<Scalars['Int']>;
  user_card_id?: Maybe<Scalars['Int']>;
  user_card_last_4_digit?: Maybe<Scalars['Int']>;
  user_card_network_type?: Maybe<UserCardNetworkType>;
  user_card_status?: Maybe<UserCardStatus>;
  user_card_token?: Maybe<Scalars['String']>;
  user_card_updated?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type UserCardCreateInput = {
  is_default_card?: InputMaybe<Scalars['Boolean']>;
  user_card_address?: InputMaybe<Scalars['String']>;
  user_card_address2?: InputMaybe<Scalars['String']>;
  user_card_cardholder_name?: InputMaybe<Scalars['String']>;
  user_card_cvv?: InputMaybe<Scalars['String']>;
  user_card_expiration_date?: InputMaybe<Scalars['String']>;
  user_card_nationality_id?: InputMaybe<Scalars['Int']>;
  user_card_no?: InputMaybe<Scalars['String']>;
  user_card_postcode?: InputMaybe<Scalars['Int']>;
  user_card_state_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type UserCardDropdown = {
  __typename?: 'UserCardDropdown';
  is_default_card?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  user_card_cardholder_name?: Maybe<Scalars['String']>;
  user_card_expiration_month?: Maybe<Scalars['Int']>;
  user_card_expiration_year?: Maybe<Scalars['Int']>;
  user_card_id?: Maybe<Scalars['Int']>;
  user_card_last_4_digit?: Maybe<Scalars['Int']>;
  user_card_network_type?: Maybe<Scalars['String']>;
};

export type UserCardListing = {
  __typename?: 'UserCardListing';
  is_default_card?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  user_card_cardholder_name?: Maybe<Scalars['String']>;
  user_card_created?: Maybe<Scalars['DateTime']>;
  user_card_expiration_month?: Maybe<Scalars['Int']>;
  user_card_expiration_year?: Maybe<Scalars['Int']>;
  user_card_id?: Maybe<Scalars['Int']>;
  user_card_last_4_digit?: Maybe<Scalars['Int']>;
  user_card_network_type?: Maybe<Scalars['String']>;
  user_card_status?: Maybe<Scalars['String']>;
  user_card_updated?: Maybe<Scalars['DateTime']>;
};

export type UserCardListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  is_default_card?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  user_card_network_type?: InputMaybe<UserCardNetworkType>;
  user_card_status?: InputMaybe<UserCardStatus>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** A paginated list of UserCardListing items. */
export type UserCardListingPaginator = {
  __typename?: 'UserCardListingPaginator';
  /** A list of UserCardListing items. */
  data: Array<UserCardListing>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum UserCardNetworkType {
  /** American Express */
  AmericanExpress = 'AMERICAN_EXPRESS',
  /** Master */
  Master = 'MASTER',
  /** Visa */
  Visa = 'VISA',
}

export enum UserCardStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type UserCardUpdateDefaultInput = {
  is_default_card?: InputMaybe<Scalars['Boolean']>;
  user_card_id?: InputMaybe<Scalars['Int']>;
};

export type UserCreateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_alternative_email?: InputMaybe<Scalars['String']>;
  user_alternative_mobile?: InputMaybe<Scalars['String']>;
  user_city_id?: InputMaybe<Scalars['Int']>;
  user_code?: InputMaybe<Scalars['String']>;
  user_dob?: InputMaybe<Scalars['Date']>;
  user_email: Scalars['String'];
  user_fullname: Scalars['String'];
  user_gender: UserGender;
  user_mobile: Scalars['String'];
  user_nationality_id?: InputMaybe<Scalars['Int']>;
  user_nric?: InputMaybe<Scalars['String']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_profile_image?: InputMaybe<Scalars['Upload']>;
  user_role_id?: InputMaybe<Scalars['Int']>;
  user_state_id?: InputMaybe<Scalars['Int']>;
  user_status?: InputMaybe<UserStatus>;
  user_type_id: Scalars['Int'];
  username: Scalars['String'];
};

export enum UserGender {
  Female = 'Female',
  Male = 'Male',
}

export type UserLessDetail = {
  __typename?: 'UserLessDetail';
  user_email?: Maybe<Scalars['String']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_status?: Maybe<UserStatus>;
};

export type UserLessDetailWithImages = {
  __typename?: 'UserLessDetailWithImages';
  user_email?: Maybe<Scalars['String']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_profile_image?: Maybe<Images>;
};

export type UserLessDetailWithRoleAndImages = {
  __typename?: 'UserLessDetailWithRoleAndImages';
  user_email?: Maybe<Scalars['String']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_profile_image?: Maybe<Images>;
  user_role?: Maybe<Role>;
  user_status?: Maybe<UserStatus>;
};

export type UserListing = {
  __typename?: 'UserListing';
  customer_user?: Maybe<Array<Maybe<Customer>>>;
  user_address?: Maybe<Scalars['String']>;
  user_address2?: Maybe<Scalars['String']>;
  user_alternative_email?: Maybe<Scalars['String']>;
  user_alternative_mobile?: Maybe<Scalars['String']>;
  user_city?: Maybe<City>;
  user_code?: Maybe<Scalars['String']>;
  user_created: Scalars['DateTime'];
  user_dob?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_gender?: Maybe<Scalars['String']>;
  user_id: Scalars['Int'];
  user_mobile?: Maybe<Scalars['String']>;
  user_nationality?: Maybe<Country>;
  user_nric?: Maybe<Scalars['String']>;
  user_postcode?: Maybe<Scalars['String']>;
  user_profile_image?: Maybe<Images>;
  user_role?: Maybe<Role>;
  user_state?: Maybe<State>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_updated: Scalars['DateTime'];
  username?: Maybe<Scalars['String']>;
};

export type UserListingInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  user_gender?: InputMaybe<UserGender>;
  user_role_id?: InputMaybe<Scalars['Int']>;
  user_status?: InputMaybe<UserStatus>;
  user_type_group?: InputMaybe<UserTypeGroup>;
  user_type_id?: InputMaybe<Scalars['Int']>;
};

export type UserListingLessDetail = {
  __typename?: 'UserListingLessDetail';
  user_fullname?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** A paginated list of UserListing items. */
export type UserListingPaginator = {
  __typename?: 'UserListingPaginator';
  /** A list of UserListing items. */
  data: Array<UserListing>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserOtpInput = {
  otp_type: Scalars['String'];
  user_mobile: Scalars['String'];
};

export enum UserStatus {
  Active = 'active',
  Pending = 'pending',
  Suspend = 'suspend',
}

export type UserType = {
  __typename?: 'UserType';
  user_type_group?: Maybe<Scalars['String']>;
  user_type_id: Scalars['Int'];
  user_type_name: Scalars['String'];
  user_type_slug: Scalars['String'];
};

export enum UserTypeGroup {
  Management = 'management',
  User = 'user',
}

export type UserUpdateInput = {
  customer_id?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_alternative_email?: InputMaybe<Scalars['String']>;
  user_alternative_mobile?: InputMaybe<Scalars['String']>;
  user_city_id?: InputMaybe<Scalars['Int']>;
  user_dob?: InputMaybe<Scalars['Date']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_fullname: Scalars['String'];
  user_gender: UserGender;
  user_id: Scalars['Int'];
  user_language?: InputMaybe<Language>;
  user_mobile: Scalars['String'];
  user_nationality_id?: InputMaybe<Scalars['Int']>;
  user_nric?: InputMaybe<Scalars['String']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_profile_image?: InputMaybe<Scalars['Upload']>;
  user_role_id: Scalars['Int'];
  user_state_id?: InputMaybe<Scalars['Int']>;
  user_status: UserStatus;
  user_type_id: Scalars['Int'];
  username: Scalars['String'];
};

export type UserUpdatePasswordInput = {
  current_password?: InputMaybe<Scalars['String']>;
  new_password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
};
